module.exports = __webpack_public_path__ + "img/Ecom-white.81d85520.svg";